import {
  Center,
  Modal,
  ModalContent,
  ModalOverlay,
  Spinner,
} from '@chakra-ui/react';

import { useGlobalStateMachine } from '../GlobalStore';

const ClickGuard: React.FC = () => {
  const { state } = useGlobalStateMachine();

  return (
    <Modal
      isCentered
      isOpen={state.isGuarding}
      onClose={() => {
        return;
      }}
    >
      <ModalOverlay></ModalOverlay>
      <ModalContent
        backgroundColor={'transparent'}
        border={'none'}
        boxShadow={'none'}
      >
        <Center>
          <Spinner
            thickness="4px"
            speed="0.75s"
            emptyColor="gray.200"
            color="blue.500"
            size="md"
          />
        </Center>
      </ModalContent>
    </Modal>
  );
};

export default ClickGuard;
